import { render, staticRenderFns } from "./ExploreTrend.vue?vue&type=template&id=b260883e&scoped=true"
import script from "./ExploreTrend.vue?vue&type=script&lang=js"
export * from "./ExploreTrend.vue?vue&type=script&lang=js"
import style0 from "./ExploreTrend.vue?vue&type=style&index=0&id=b260883e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b260883e",
  null
  
)

export default component.exports